enum PaymentMethod {
  CreditCard = 1,
  PhoneCredits = 2,
  Invoice = 4,
  InvoiceRecurrent = 9
}

export default PaymentMethod
